module.exports = __webpack_public_path__ + "static/LOGO 11-5a598cda081f31d7c661aafbee7fede6.png";